import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./highlights.html";
import { parseNewLines } from '~/modules/utilities/text';
class Highlights extends LightningElement {
  constructor(...args) {
    super(...args);
    this.highlights = void 0;
    this.highlightsLabel = void 0;
    this.gridSize = '1:3';
  }
  renderedCallback() {
    this.setDividerColors();
  }
  setDividerColors() {
    //the colors below are the 60% variants of the C360 Vibrant Core Palette - we will vary the divider colors across these colors
    const colors = ['#FF5D2D', '#DD7A01', '#3BA755', '#1B96FF', '#7F8CED', '#CA8501', '#06A59A', '#0D9DDA'];
    const dividers = this.template.querySelectorAll('.divider');
    for (let i = 0; i < dividers.length; i++) {
      //divide the colors length by the list index so that we will start at the beginning of the list of colors after using them all
      const color = colors[i % colors.length];
      dividers[i].style.background = color;
    }
  }
  get formattedHighlights() {
    return this.highlights.map(highlight => {
      return parseNewLines(highlight);
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Highlights, {
  publicProps: {
    highlights: {
      config: 0
    },
    highlightsLabel: {
      config: 0
    },
    gridSize: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Highlights, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;